module.exports = __webpack_public_path__ + "img/Mezink.0287e6fd.png";